import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as React from 'react';
import { cn } from '../../../utils';
import { Z_INDEX } from './constants';

/**
 * Sidebar-specific TooltipContent that does NOT use portals.
 * This avoids React StrictMode portal cleanup warnings.
 *
 * Note: This only works because the sidebar is fixed position
 * and we handle overflow constraints differently.
 */
/* eslint-disable react/prop-types */
export const SidebarTooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      'z-50 rounded border dark bg-background px-2.5 py-2 text-xs font-normal text-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
      className
    )}
    style={{
      zIndex: Z_INDEX.TOOLTIP,
      ...props.style,
    }}
    {...props}
  />
));
/* eslint-enable react/prop-types */
SidebarTooltipContent.displayName = 'SidebarTooltipContent';
